// extracted by mini-css-extract-plugin
module.exports = {"portfolio":"Portfolio_portfolio__YaYrM","title":"Portfolio_title__7IP8F","blocks":"Portfolio_blocks__1rXcK"};